<template>
    <TopTab style=" width: 100%;"/>
    <div class="homeopyright-container">
        <img src="@/assets/imgs/版权中心.jpg" />
    </div>
    <FooterBar />
</template>
<script setup>
import TopTab from '../components/TopTab.vue'
import FooterBar from '../components/FooterBar.vue'
</script>
<style scoped lang="scss">
.homeopyright-container {
    width: 100%;
    img{
        width: 100%;
    }
}
</style>